import React from 'react';
import { Button } from 'react-bootstrap';
import { successToast } from '../../utils/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { faCopy } from '@fortawesome/free-solid-svg-icons';


export default function CopyField(props) {
    const { overlayKey,fieldName, data, datatitle, icon = faCopy, placement = "top", children = null } = props;
    return <div id={`${fieldName}-tooltip-container-${overlayKey}-top`}><OverlayTrigger trigger="click" key={overlayKey} placement={placement} overlay={
        <Popover id={`email-tooltip-${overlayKey}-top`}>
          <Button variant="primary"><FontAwesomeIcon icon={icon} onClick={async (e) =>  {
            navigator.clipboard.writeText(data);
            await successToast(`${datatitle} ha sido copiado`);
            setTimeout(document.getElementById(`${fieldName}-tooltip-container-${overlayKey}-top`).childNodes[0].click(), 1000)
            }}></FontAwesomeIcon></Button>
        </Popover>
      }>{children}</OverlayTrigger></div>
}